import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import React from "react";
import ExploreEvents from "../ExploreEvents";

const { Panel } = Collapse;

const ExploreEventsAccordian = ({ fullwidthEvent }) => (
  <Collapse
    bordered={false}
    style={{ width: fullwidthEvent ? "100%" : "85%" }}
    defaultActiveKey={["ExploreEventsAccordian"]}
    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
    className="site-collapse-custom-collapse  sideItem">
    <Panel header="Explore Events" key="Explore Events" className="site-collapse-custom-panel">
      <ExploreEvents />
    </Panel>
  </Collapse>
);

export default ExploreEventsAccordian;
